module.exports = __webpack_public_path__ + "img/f9c470559374134d8ee7bf8d825de527.77cef7d6.jpg";